var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "buttons-section-main float-l width-full" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box general-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" General Buttons ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Success\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Warning\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "danger" } },
                              [
                                _vm._v(
                                  "\n                                    Danger\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box outline-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" Button with outline ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Success\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Warning\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "danger" } },
                              [
                                _vm._v(
                                  "\n                                    Danger\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box general-button rounded-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" Rounded Buttons ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Success\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Warning\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "danger" } },
                              [
                                _vm._v(
                                  "\n                                    Danger\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box rounded-button outline-button bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" Rounded outlined Buttons ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Success\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mr-17 pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Warning\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "pb-2 float-l" },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "danger" } },
                              [
                                _vm._v(
                                  "\n                                    Danger\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box general-button button-size bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full mr-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" Button Sizes ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mr-17 pb-2 float-l btn-primary-large"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "lg", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-secondary mt-7"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-s mt-11"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Small Button\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-tiny mt-13"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Tiny Button\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 float-l mt-40"
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "button-box general-button rounded-button button-size bg-color-ffffff radius-5 border-d3dee3 default-bx-shadow float-l width-full ml-20"
                      },
                      [
                        _c(
                          "h5",
                          {
                            staticClass:
                              "color-666666 font-text-regular-san width-full float-l mb-30"
                          },
                          [_vm._v(" Button Sizes with Rounded ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "mr-17 pb-2 float-l btn-primary-large"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "lg", variant: "primary" } },
                              [
                                _vm._v(
                                  "\n                                    Primary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-secondary mt-7"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "secondary" } },
                              [
                                _vm._v(
                                  "\n                                    Secondary\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-s mt-11"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "success" } },
                              [
                                _vm._v(
                                  "\n                                    Small Button\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "mr-17 pb-2 float-l btn-primary-tiny mt-13"
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { size: "sm", variant: "warning" } },
                              [
                                _vm._v(
                                  "\n                                    Tiny Button\n                                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 float-l mt-40" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "bg-color-ffffff radius-5 border-d3dee3 button-box default-bx-shadow float-l width-full mr-20"
                    },
                    [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "color-666666 font-text-regular-san width-full float-l mb-30"
                        },
                        [_vm._v(" Button with Icon ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-icon-left general-button col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9 float-l"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn-icon-top float-l width-full"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Primary ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmarrow-point-to-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "secondary"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Secondary ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmarrow-point-to-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Success ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmcheck-mark"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "warning"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Warning ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "hi-icon icon-abmwarning"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "sm", variant: "danger" }
                                      },
                                      [
                                        _c("span", [_vm._v(" Danger ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "hi-icon icon-abmalert"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "pb-2 float-l mail-icon-btn" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmenvelope"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(" Mail ")])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "btn-icon-top rounded-button float-l width-full mt-15"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Primary ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmarrow-point-to-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "secondary"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Secondary ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmarrow-point-to-right"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "success"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Success ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmcheck-mark"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "warning"
                                        }
                                      },
                                      [
                                        _c("span", [_vm._v(" Warning ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "hi-icon icon-abmwarning"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "mr-17 pb-2 float-l" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "sm", variant: "danger" }
                                      },
                                      [
                                        _c("span", [_vm._v(" Danger ")]),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "hi-icon icon-abmalert"
                                        })
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "pb-2 float-l mail-icon-btn mail-icon-btn-radius"
                                  },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "primary"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "hi-icon icon-abmenvelope"
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(" Mail ")])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "btn-icon-right col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3 float-l"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "dropdown-small col-6 float-l" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "m-md-2",
                                        attrs: { id: "ddown1", text: "Action" }
                                      },
                                      [
                                        _c("b-dropdown-item", [
                                          _vm._v("Action")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-dropdown-item", [
                                          _vm._v("Another Action")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-dropdown-item", [
                                          _vm._v("Something else here")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dropdown-large col-6 float-l" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "row" },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "mt-9",
                                        attrs: { id: "ddown1", text: "Action" }
                                      },
                                      [
                                        _c("b-dropdown-item", [
                                          _vm._v("Action")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-dropdown-item", [
                                          _vm._v("Another Action")
                                        ]),
                                        _vm._v(" "),
                                        _c("b-dropdown-item", [
                                          _vm._v("Something else here")
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "pagination-manual-main float-l col-12 mt-50"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "color-666666 font-text-regular-san width-full float-l mb-30"
                              },
                              [_vm._v(" Button toolbar pagination ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {},
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    align: "center",
                                    "total-rows": 100,
                                    "per-page": 10
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header-top-container" }, [
      _c("div", { staticClass: "page-name" }, [_vm._v("Buttons")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6abebdbe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6abebdbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons.vue
// module id = null
// module chunks = 